
import Vue from "vue";
import OfficialHeader from "@/components/common/OfficialHeader.vue";
import MainFooter from "@/components/common/MainFooter.vue";
import EnterpriseFooter from "@/components/common/TheEnterpriseFooter.vue";

export default Vue.extend({
  name: "App",
  components: {
    OfficialHeader,
    MainFooter,
    EnterpriseFooter
  },
  created() {
    window.addEventListener("beforeunload", this.beforeUnload, false);
  },
  methods: {
    beforeUnload: function() {
      localStorage.setItem("theme.dark", this.$vuetify.theme.dark.toString());
    }
  }
});
